"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var base = '/api/email-batch';
/**
 * Create an email batch via LP → comms-service for edit-tracking.
 * @param {{
 *   projectId: number,
 *   segmentId: number,
 *   listId?: number | null,
 *   templateName: string,
 *   baseline: { subject: string, body: string },
 *   final: { subject: string, body: string },
 * }} data
 * @returns {Promise<{ ok: boolean, batchId: number }>}
 */
function create(data) {
    return api_1.default.post(base, data).then(api_1.extractData).catch(api_1.errorHandler);
}
exports.create = create;
var api = {
    create: create,
};
exports.default = api;
